"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariableCorrelationTable = void 0;
var React = require("react");
var styles = require("../styles/VariableCorrelationTable");
var colors = require("../util/colors");
var sizes = require("../util/sizes");
var VariableCorrelationTable = function (props) {
    var data = props.data;
    var width = props.width || sizes.widthWide;
    var height = props.height || sizes.heightTall;
    var sortedData = data
        .map(function (n) {
        return {
            name: n.name,
            correlation: Math.min(n.correlation * 100, 100),
        };
    })
        .sort(function (a, b) { return b.correlation - a.correlation; });
    var renderProgress = function (percent) {
        var _a;
        return (React.createElement("div", { className: styles.ProgressBarContainer },
            React.createElement("div", { role: "progressbar", className: styles.ProgressBar, style: { width: percent, backgroundColor: (_a = props.color) !== null && _a !== void 0 ? _a : colors.background01 } })));
    };
    var getRows = function () {
        return sortedData.map(function (_a, index) {
            var name = _a.name, correlation = _a.correlation;
            var correlationPercent = correlation.toFixed(2) + "%";
            // Remove border on last row
            var borderClass = index < sortedData.length - 1 ? styles.VarCorrelationTableCellBorder : '';
            return (React.createElement("tr", { key: name + "_" + index },
                React.createElement("td", { className: styles.VarCorrelationTableNameCell + " " + borderClass }, name),
                React.createElement("td", { className: styles.VarCorrelationTableCorrelationCell + " " + borderClass }, correlationPercent),
                React.createElement("td", { className: styles.VarCorrelationTableBarCell + " " + borderClass }, renderProgress(correlationPercent))));
        });
    };
    return (React.createElement("div", { style: { width: width, height: height, maxHeight: height, overflowY: 'scroll' } },
        React.createElement("table", { className: styles.VarCorrelationTableWithChart },
            React.createElement("tbody", null, getRows()))));
};
exports.VariableCorrelationTable = VariableCorrelationTable;
//# sourceMappingURL=VariableCorrelationTable.js.map